import styled from 'styled-components';

import { color } from '../../../atoms/colors';
import { font } from '../../../atoms/typography';
import { spacing } from '../../../atoms/spacing';
import { atMinWidth } from '../../../atoms/breakpoints';

export const Container = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border-bottom: 1px solid ${color.darkBlue[50]};
  padding: ${spacing[12]} ${spacing[24]};

  .error-msg {
    width: 100%;
    ${font('text', 'xs', '600')}
    color: ${color.primary[700]};
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: ${spacing[16]};
  align-items: center;

  ${atMinWidth.sm`
    gap: ${spacing[0]};
  `}
`;

export const FormControl = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${spacing[8]};
  /* border-bottom: 1px solid ${color.darkBlue[50]}; */
  ${atMinWidth.sm`
    border-bottom: none;
  `}
`;

export const Label = styled.label`
  visibility: hidden;
`;

export const Input = styled.input`
  &&& {
    width: 100%;
    border: none;
    outline: none;
    background-color: ${color.common.white};
    padding: ${spacing[6]} ${spacing[0]};
  }

  &,
  &::placeholder {
    ${font('text', 'lg', 400)}
    color: ${color.darkBlue[600]};
  }
`;

export const Button = styled.button`
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing[2]} ${spacing[8]};
  background-color: ${color.common.white};
  border: 1px solid ${color.darkBlue[400]};
  border-radius: ${spacing[6]};
  ${font('text', 'sm', '700')}
  color: ${color.darkBlue[600]};
  transition: all 250ms ease-in-out;

  &:hover,
  &.hovered {
    color: ${color.common.white};
    background: ${color.darkBlue[700]};
    border: 1px solid ${color.darkBlue[700]};
  }

  &:focus,
  &.focused {
    color: ${color.common.white};
    background: ${color.darkBlue[1000]};
    border: 1px solid ${color.darkBlue[1000]};
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #bbe2ff;
  }
`;
